export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#FFFFFF] text-[#0A0A0A]"
      data-testid="site-footer"
    >
      {/* Massive type band */}
      <div className="border-b border-[#0A0A0A] overflow-hidden">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-12 md:py-16">
          <div
            className="font-display text-[26vw] lg:text-[18rem] leading-[0.85] tracking-tighter text-outline-thick"
            aria-hidden="true"
          >
            PARAUX
          </div>
          <p className="label-mono text-[#595959] mt-4">
            Parastou Saba · UX Designer &amp; Consultant
          </p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-10 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-4">
          <p className="label-mono text-[#595959]">© {year} — Parastou Saba</p>
          <p className="label-mono text-[#595959] mt-2">
            UX Designer &amp; Consultant · Toronto, Canada
          </p>
        </div>
        <div className="col-span-12 md:col-span-4">
          <p className="label-mono text-[#595959] mb-3">Index</p>
          <ul className="space-y-1.5">
            <li>
              <a className="hover:text-[#4C1D95] transition-colors" href="/#work">
                Work
              </a>
            </li>
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="/#about"
              >
                About
              </a>
            </li>
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="/services"
              >
                Services
              </a>
            </li>
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="/#contact"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div className="col-span-12 md:col-span-4">
          <p className="label-mono text-[#595959] mb-3">Elsewhere</p>
          <ul className="space-y-1.5">
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="https://www.linkedin.com/in/parastou-saba-6665b9150"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin"
              >
                LinkedIn ↗
              </a>
            </li>
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="https://www.instagram.com/the.directdesigner/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
              >
                Instagram ↗
              </a>
            </li>
            <li>
              <a
                className="hover:text-[#4C1D95] transition-colors"
                href="https://www.upwork.com/freelancers/parastous?mp_source=share"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-upwork"
              >
                Upwork ↗
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
